import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyle from './Styles/globalStyle';

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
        <BrowserRouter>
            <GlobalStyle />
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </BrowserRouter>
    );
}


